export default "__VITE_ASSET__Cp0dfEax__"